import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const handleScroll = () => {
    document.getElementById('image-exercise')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[70vh] md:min-h-[80vh] flex items-center justify-center px-4 md:px-8 overflow-hidden bg-gradient-to-b from-navy to-lightgray" data-id="element-116">
      {/* LiveWright text logo */}
      <div className="absolute top-6 left-6 md:top-8 md:left-8 z-20" data-id="element-117">
        <span className="text-white font-bold tracking-tight" style={{
        fontSize: '22px'
      }} data-id="element-118">
          LiveWright
        </span>
      </div>

      {/* Faint radial glow */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center" data-id="element-119">
        <div className="w-[800px] h-[800px] rounded-full bg-[radial-gradient(circle,rgba(0,178,198,0.1)_0%,rgba(0,178,198,0)_70%)]" data-id="element-120" />
      </div>

      <motion.div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center pt-10 md:pt-0" initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} data-id="element-121">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight" data-id="element-122">
          What If You Could See What's Really Driving You?
        </h1>

        <p className="text-white/90 text-base md:text-xl max-w-2xl mb-8 md:mb-10 font-medium" data-id="element-123">
          Take a 2-minute image exercise and discover what your choices reveal
          about your deepest motivations.
        </p>

        <button onClick={handleScroll} className="bg-teal text-white rounded-full px-6 py-3 md:px-8 md:py-4 text-base md:text-lg font-semibold shadow-lg hover:scale-105 transition-transform duration-300 mb-6" data-id="element-124">
          Start the Image Exercise
        </button>

        <p className="text-white text-sm font-normal" data-id="element-125">
          As seen on Oprah, Today Show, CNN • Wright Foundation — 30+ Years of
          Research
        </p>
      </motion.div>
    </section>;
}